// extracted by mini-css-extract-plugin
export default {"priceContainer":"styles_priceContainer__oK10U","active":"styles_active__BUKuY","price":"styles_price__1fOUE","label":"styles_label__wyfmB"};